import axiosInstance from "../../axiosInstance";

const BASE_URL = "/crm/teacher-accounts";

export const getTeacherAccounts = async (params = {}) => {
  const res = await axiosInstance.get(BASE_URL, { params });
  return res.data;
};

export const getTeacherAccountTeachingLevelStats = async (params = {}) => {
  const res = await axiosInstance.get(`${BASE_URL}/stats/teaching-levels`, { params });
  return res.data;
};

/** Danh sách trường (đơn vị) có GV đối tác — dùng cho mini dashboard drill-down */
export const getTeacherAccountsBySchools = async (params = {}) => {
  const res = await axiosInstance.get(`${BASE_URL}/by-schools`, { params });
  return res.data;
};

export const getTeacherAccountById = async (id) => {
  const res = await axiosInstance.get(`${BASE_URL}/${id}`);
  return res.data;
};

export const createTeacherAccount = async (data) => {
  const res = await axiosInstance.post(BASE_URL, data);
  return res.data;
};

export const updateTeacherAccount = async (id, data) => {
  const res = await axiosInstance.put(`${BASE_URL}/${id}`, data);
  return res.data;
};

export const deleteTeacherAccount = async (id) => {
  const res = await axiosInstance.delete(`${BASE_URL}/${id}`);
  return res.data;
};

export const toggleTeacherAccountStatus = async (id, is_active) => {
  const res = await axiosInstance.patch(`${BASE_URL}/${id}/status`, { is_active });
  return res.data;
};

/** Admin đặt lại mật khẩu tạm — gửi email cho GV */
export const resetTeacherAccountPassword = async (id) => {
  const res = await axiosInstance.post(`${BASE_URL}/${id}/reset-password`);
  return res.data;
};

/** Import hàng loạt từ Excel/CSV — gắn một chi nhánh + một khách hàng (trường). */
export const importTeacherAccounts = async (
  file,
  { branch_id, partner_customer_id, default_course_ids = [] }
) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("branch_id", branch_id);
  formData.append("partner_customer_id", partner_customer_id);
  if (Array.isArray(default_course_ids) && default_course_ids.length > 0) {
    formData.append("default_course_ids", JSON.stringify(default_course_ids));
  }
  const res = await axiosInstance.post(`${BASE_URL}/import`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
    timeout: 120_000,
  });
  return res.data;
};

/** Thiết bị đăng nhập APP (GV đối tác) */
export const getTeacherLoginDevices = async (employeeId) => {
  const res = await axiosInstance.get(`${BASE_URL}/${employeeId}/login-devices`);
  return res.data;
};

export const deleteTeacherLoginDevice = async (employeeId, deviceId) => {
  const res = await axiosInstance.delete(`${BASE_URL}/${employeeId}/login-devices/${deviceId}`);
  return res.data;
};

export const getTeacherAccountImportTemplateCourses = async (branchId) => {
  const res = await axiosInstance.get(`${BASE_URL}/import-template-courses`, {
    params: { branch_id: branchId },
  });
  return res.data?.courses || [];
};

export const getTeacherAccountSoftwareUsage = async (id, params = {}) => {
  const res = await axiosInstance.get(`${BASE_URL}/${id}/software-usage`, { params });
  return res.data;
};

export const resolveTeacherDeviceRequest = async (requestId, action) => {
  const res = await axiosInstance.patch(`${BASE_URL}/device-access-requests/${requestId}`, {
    action,
  });
  return res.data;
};
